import { render } from "./submission-panel.vue?vue&type=template&id=29f1c94e&scoped=true&ts=true"
import script from "./submission-panel.vue?vue&type=script&lang=ts"
export * from "./submission-panel.vue?vue&type=script&lang=ts"

import "./submission-panel.vue?vue&type=style&index=0&id=29f1c94e&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29f1c94e"]])

export default __exports__